import React from "react";
import BottomFloat from "./BottomFloat";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import t from "../../Locale";

const useStyles = makeStyles((theme) => ({
	bottomFloat: {
		border: "0.5px solid #C4C4C4",
		boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
		position: "absolute",
		marginLeft: 8,

		// orig
		// bottom: -20,
		// height: 70,

		bottom: -20 + (process.env.REACT_APP_YES_APP === undefined ? 0 : 60),
		height: process.env.REACT_APP_YES_APP === undefined ? 70 : 53,
	},
	bottomFloatRight: {
		paddingLeft: 32,
		// paddingTop: 8,
		paddingTop: 0,
		backgroundColor: "#fff",
	},
	fullWidthButton: {
		// height: "100%",
		borderRadius: 0,
		fontSize: 18,
		height: 50,
		lineHeight: "16px",
	},
}));

const BottomFloat2 = ({
	title = t("Add To Bet Slip"),
	onClick = () => {},
	total = 0,
	disabled = false,
	moneyTitle = "Total Stake",
	style = {},
	wishListActive = false,
	wishListClick = () => {},
}) => {
	const classes = useStyles();
	return (
		<BottomFloat style={{ ...style }}>
			<Grid
				container
				className={classes.bottomFloat}
				style={{ background: "#fff" }}
			>
				<Grid
					item
					xs={wishListActive ? 4 : 5}
					className={classes.bottomFloatRight}
					style={wishListActive ? { paddingLeft: 0, textAlign: "center" } : {}}
				>
					<Typography
						variant="subtitle1"
						style={{
							fontSize: 14,
							height: 24,
							overflowY: "hidden",
						}}
					>
						{t(moneyTitle)}:
					</Typography>
					<Typography variant="h4" style={{ fontSize: 22 }}>
						$ {total?.toFixed(2)}
					</Typography>
				</Grid>
				{wishListActive ? (
					<Grid item xs={3}>
						<div
							style={{
								height: "calc(100% - 19px)",
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							{/* eslint-disable-next-line  */}
							<a
								style={{ color: "blue", cursor: "pointer" }}
								onClick={wishListClick}
							>
								Save as Wishlist
							</a>
						</div>
					</Grid>
				) : (
					<></>
				)}
				<Grid item xs={wishListActive ? 5 : 7}>
					<Button
						variant="contained"
						color="primary"
						fullWidth
						className={classes.fullWidthButton}
						onClick={onClick}
						disabled={disabled}
						style={{
							backgroundColor: disabled ? "grey" : style.color,
						}}
					>
						{t(title)}
					</Button>
				</Grid>
			</Grid>
		</BottomFloat>
	);
};

export default BottomFloat2;
